import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { ProfileModule } from '../profile/profile.module';
import { HierarchyController } from './hierarchy.controller';
import { HierarchyEntity } from './hierarchy.entity';
import { HierarchyService } from './hierarchy.services';

@Module({
    imports:[
        TypeOrmModule.forFeature([HierarchyEntity]),
        ProfileModule
    ],
    controllers:[HierarchyController],
    providers:[HierarchyService],
    exports:[HierarchyService]
})
export class HierarchyModule {}
